__turbopack_context__.v({
  "accountLink": "styles-module-scss-module__LwyHrG__accountLink",
  "divider": "styles-module-scss-module__LwyHrG__divider",
  "dividerText": "styles-module-scss-module__LwyHrG__dividerText",
  "forgotPass": "styles-module-scss-module__LwyHrG__forgotPass",
  "forgotPassLnk": "styles-module-scss-module__LwyHrG__forgotPassLnk",
  "link": "styles-module-scss-module__LwyHrG__link",
  "loginContent": "styles-module-scss-module__LwyHrG__loginContent",
  "subTitle": "styles-module-scss-module__LwyHrG__subTitle",
});
